import React, { Component } from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import type { ControlProps } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { ItemGroup } from '../../../model/index.tsx';
import { stopImmediatePropagation } from '../../../services/stop-immediate-propagation/index.tsx';

type Props = {
	isSearchEnabled: boolean;
};

// eslint-disable-next-line jira/react/no-class-components
export default class Control extends Component<Props & ControlProps<ItemGroup>> {
	static defaultProps = {
		isSearchEnabled: false,
	};

	onClick = stopImmediatePropagation(noop);

	renderFieldSearch() {
		return (
			<ControlWrapper
				{...this.props.innerProps}
				onClick={this.onClick}
				ref={this.props.innerRef}
				// eslint-disable-next-line jira/integration/test-id-by-folder-structure
				data-testid="navigation-apps.common.compontents.switcher.switcher.control"
			>
				{this.props.children}
			</ControlWrapper>
		);
	}

	renderEmptySearch() {
		return <EmptyControlWrapper>{this.renderFieldSearch()}</EmptyControlWrapper>;
	}

	render() {
		if (!this.props.isSearchEnabled) {
			return this.renderEmptySearch();
		}

		return this.renderFieldSearch();
	}
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ControlWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `2px solid ${token('color.border')}`,
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyControlWrapper = styled.div({
	height: 0,
	overflow: 'hidden',
});
